import { FormattedMessage } from 'react-intl';
import { generatePath } from 'react-router-dom';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { FOOTBALL_PLAY_PRO_FIXTURE } from '@sorare/core/src/constants/__generated__/routes';
import { glossary } from '@sorare/core/src/lib/glossary';

const FullWidthHorizontal = styled(Horizontal)`
  width: 100%;
  flex-wrap: wrap;
`;

type Props = {
  so5FixtureSlug?: string;
  onNext?: () => void;
  onClose: () => void;
};
export const Cta = ({ so5FixtureSlug, onNext, onClose }: Props) => {
  return onNext ? (
    <Button size="medium" color="secondary" fullWidth onClick={onNext}>
      <FormattedMessage {...glossary.next} />
    </Button>
  ) : (
    <FullWidthHorizontal center>
      {so5FixtureSlug && (
        <Button
          size="medium"
          color="primary"
          fullWidth
          to={generatePath(FOOTBALL_PLAY_PRO_FIXTURE, {
            fixture: so5FixtureSlug,
          })}
        >
          <FormattedMessage
            id="LastFixtureStory.Cta.checkResults"
            defaultMessage="Check my results"
          />
        </Button>
      )}
      <Button size="medium" color="secondary" fullWidth onClick={onClose}>
        <FormattedMessage {...glossary.close} />
      </Button>
    </FullWidthHorizontal>
  );
};
